import * as React from 'react';
import LexiconLanguage from '../new/lexicons/LexiconLanguage';
import LexiconSearcher from '../new/lexicons/LexiconSearcher';
import LexiconStem from '../new/lexicons/LexiconStem';
import LexiconStemResult from '../new/lexicons/LexiconStemResult';
import WordPosition from '../new/lexicons/WordPosition';
import LexiconLanguageSelect from './LexiconLanguageSelect';
import './LexiconSearch.css';
import LexiconSearchBox from './LexiconSearchBox';
import LexiconSearchResults from './LexiconSearchResults';

interface Props {
    searcher: LexiconSearcher;
    wordPosition?: WordPosition;
    onStemSearched: (stem: LexiconStem) => void;
    onStemSelect: (stem: LexiconStem) => void;
}

interface State {
    language: LexiconLanguage;
    searchText: string;
    stems: LexiconStemResult | null;
}

export default class LexiconSearch extends React.Component<Props, State> {

    private languageStates = new Map<LexiconLanguage, State>();

    public constructor(props: Props) {
        super(props);
        this.state = {
            language: LexiconLanguage.Hebrew,
            searchText: '',
            stems: null
        };
        this.searchStems = this.searchStems.bind(this);
        this.onLanguageSelect = this.onLanguageSelect.bind(this);
        this.onSearchTextChange = this.onSearchTextChange.bind(this);
        this.onSearchSubmit = this.onSearchSubmit.bind(this);
        this.handleStemResult = this.handleStemResult.bind(this);
        this.updateLanguageState = this.updateLanguageState.bind(this);
    }

    public componentDidMount() {
        if (this.props.wordPosition) {
            this.searchStems(this.props.wordPosition);
        }
    }

    public componentDidUpdate(prevProps: Props) {
        if (this.props.wordPosition && (!prevProps.wordPosition ||
                this.props.wordPosition.toString() !== prevProps.wordPosition.toString())) {
            this.searchStems(this.props.wordPosition);
        }
    }

    public render() {
        return (
            <div className="LexiconSearch">
                <LexiconLanguageSelect
                    currentLanguage={this.state.language}
                    onSelect={this.onLanguageSelect} />
                <LexiconSearchBox
                    language={this.state.language}
                    searchText={this.state.searchText}
                    onChange={this.onSearchTextChange}
                    onSubmit={this.onSearchSubmit} />
                <LexiconSearchResults
                    results={this.state.stems}
                    onClick={this.props.onStemSelect} />
            </div>
        );
    }

    private searchStems(wordPosition: WordPosition) {
        this.props.searcher.searchStems(wordPosition).then(this.handleStemResult); // TODO: Catch.
    }

    private onLanguageSelect(language: LexiconLanguage) {
        this.updateLanguageState(this.languageStates.get(language) || {
            language,
            searchText: '',
            stems: null
        });
    }

    private onSearchTextChange(text: string) {
        this.setState({ searchText: text });
    }

    private onSearchSubmit(text: string) {
        this.props.searcher.searchStems(text, this.state.language).then(this.handleStemResult); // TODO: Catch.
    }

    private handleStemResult(result: LexiconStemResult) {
        this.updateLanguageState({
            language: result.getStem().getLanguage(),
            searchText: result.getStem().getText(),
            stems: result
        });
        this.props.onStemSearched(result.getStem());
    }

    private updateLanguageState(state: State) {
        // Save current language state first.
        this.languageStates.set(this.state.language, this.state);
        this.setState(state);
    }
}
